module.exports = "<app-page></app-page>\n"